(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.flipCards = {
    attach: function (context, settings) {
      once('flip-cards', '.flip-cards-component', context).forEach(function (component) {
        const flipCards = component.querySelectorAll('[data-flip-card]');
        
        if (!flipCards.length) {
          return;
        }
        
        // Add click handler to each card
        flipCards.forEach(function(card) {
          const inner = card.querySelector('.flip-card-inner');
          
          if (!inner) {
            return;
          }
          
          card.addEventListener('click', function(e) {
            // Don't flip if clicking on a link/button inside the card back
            const backElement = card.querySelector('.flip-card-back');
            if (backElement && e.target.closest('a, button')) {
              // Allow link clicks when card is flipped
              if (card.classList.contains('flipped')) {
                return;
              }
            }
            
            // Toggle flip class
            card.classList.toggle('flipped');
            
            // Debug: Check if back content exists
            const backContent = card.querySelector('.flip-card-back-content');
            if (backContent) {
              console.log('Back content found:', backContent.innerHTML.length > 0 ? 'has content' : 'empty');
            }
            
            // Update aria state
            const isFlipped = card.classList.contains('flipped');
            card.setAttribute('aria-pressed', isFlipped);
          });
          
          // Add keyboard support
          card.setAttribute('tabindex', '0');
          card.setAttribute('role', 'button');
          card.setAttribute('aria-label', 'Flip card to see more information');
          card.setAttribute('aria-pressed', 'false');
          
          card.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              card.classList.toggle('flipped');
              const isFlipped = card.classList.contains('flipped');
              card.setAttribute('aria-pressed', isFlipped);
            }
          });
        });
      });
    }
  };

})(Drupal, once);

